import { formatAmount, toApiSort } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetTraceabilityOriginReport } from "@/services";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useInfoDialog = ({glMasterId}: {glMasterId: string}) => {
  const communityData = useSelector((state: RootState) => state.currentData.communityData);
  const currentFinanceYear = useSelector((state: RootState) => state.currentData.currentFinanceYear);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [sorting, setSorting] = useState([{ id: "createdAt", desc: true }]);
  
  const {data: traceabilityInfoData, isLoading: isLoadingInfo, refetch: refetchTraceabilityInfo, isRefetching: isRefetchingTraceabilityInfo} = useGetTraceabilityOriginReport({
    communityId: communityData?.communityId,
    year: currentFinanceYear,
    glMasterId,
    data: {
      pageNumber,
      pageSize,
      sort: toApiSort(sorting, { field: "createdAt", direction: "DESC" }),
      filters: [
        {
          field: "postingType",
          value: "PRIMARY",
          operator: "EQUAL",
        },
      ]
    },
    queryParams: {
      enabled: !!(communityData?.communityId && currentFinanceYear)
    }
  });

  useEffect(() => {
    refetchTraceabilityInfo();
  }, [pageNumber, pageSize, sorting]);

  const columns = [
    {
      accessorKey: "glAccountNumber",
      header: <div>Gl Account</div>,
      accessorFn: (row: any) => row?.glAccountNumber ? String(row?.glAccountNumber) : ""
    },
    {
      accessorKey: "docCreatedAt",
      header: <div>Date</div>,
      accessorFn: (row: any) => row?.docCreatedAt ? moment(row?.docCreatedAt).format("MM/DD/YYYY") : ""
    },
    {
      accessorKey: "documentNumber",
      header: <div>Doc ID</div>,
      accessorFn: (row: any) => row?.documentNumber ? String(row?.postDocumentHeaderId) : ""
    },
    {
      accessorKey: "postDocumentLineItemId",
      header: <div>Line ID</div>,
      accessorFn: (row: any) => row?.postDocumentHeaderId ? String(row?.postDocumentLineItemId) : ""
    },
    {
      accessorKey: "amount",
      meta: { align: "right" },
      header: <div>Amount</div>,
      accessorFn: (row: any) => formatAmount(row?.amount || "0")
    },
  ];

  return {
    columns,
    isLoadingInfo: isLoadingInfo || isRefetchingTraceabilityInfo,
    traceabilityInfoData,
    pageNumber,
    setPageNumber,
    pageSize,
    setPageSize,
    sorting,
    setSorting,
  }
}

export default useInfoDialog;
